export default "__VITE_ASSET__DuAGPUuD__"